import * as React from 'react';
import { ReactElement } from 'react';
import { createStyles, Grid, makeStyles, TextField } from '@material-ui/core';
import { ConnectAchievementBadge, ConnectCommunityUserType, ConnectUserType } from 'types/member';
import { CheckObjectValue } from 'types/common';
import {
  CONNECT_ABUSING_USER,
  CONNECT_ACHIEVEMENT_BADGE,
  connectCommunityUserTypeOption,
  connectUserTypeOption,
} from 'constants/member/connect';
import MultipleCheckboxFilter from 'components/common/searchfilter/MultipleCheckboxFilter';
import MultipleSelectFilter from 'components/common/searchfilter/MultipleSelectFilter';
import FilterElementLayout from 'components/common/searchfilter/FilterElementLayout';
import MemberSeachFilterLayout from 'components/member/memberSearchFilterLayout';
import { TextWrapper } from 'components/common/searchfilter/FilterElement';

interface Props {
  keyword: string;
  onChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDownKeyword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  connectAbusingUserStatus: CheckObjectValue;
  connectUserType: CheckObjectValue;
  connectCommunityUserType: CheckObjectValue;
  connectAchievementBadge: CheckObjectValue;
  onChangeConnectAbusingUser: (values: string[]) => void;
  onChangeConnectUserType: (values: ConnectUserType[]) => void;
  onChangeConnectCommunityUserType: (values: ConnectCommunityUserType[]) => void;
  onChangeConnectAchievementBadge: (values: ConnectAchievementBadge[]) => void;
  onClickSearch: () => void;
  onClickReset: () => void;
}

const getCheckedValues = (checkObject: CheckObjectValue): number[] =>
  Object.entries(checkObject)
    .filter(([_, isChecked]) => isChecked)
    .map(([value, _]) => Number(value));

const SearchFilter = ({
  keyword,
  onChangeKeyword,
  onKeyDownKeyword,
  connectAbusingUserStatus,
  connectAchievementBadge,
  connectUserType,
  connectCommunityUserType,
  onChangeConnectAbusingUser,
  onChangeConnectUserType,
  onChangeConnectCommunityUserType,
  onChangeConnectAchievementBadge,
  onClickSearch,
  onClickReset,
}: Props): ReactElement => {
  const connectAbusingUserCheckboxes = Object.entries(connectAbusingUserStatus)
    .filter(([_, isChecked]) => isChecked)
    .map(([value, _]) => value);

  const connectUserTypes = getCheckedValues(connectUserType);
  const connectCommunityUserTypes = getCheckedValues(connectCommunityUserType);
  const connectAchievementBadges = getCheckedValues(connectAchievementBadge);

  const classes = makeStyles(() =>
    createStyles({
      root: {
        width: '30%',
      },
    }),
  )();

  return (
    <MemberSeachFilterLayout getSearchResult={onClickSearch} resetFilter={onClickReset}>
      <Grid>
        <Grid item xs={12}>
          <FilterElementLayout label={'Keyword'} gridSize={1}>
            <TextField
              classes={classes}
              placeholder="Email, Domain"
              value={keyword}
              onChange={onChangeKeyword}
              onKeyDown={onKeyDownKeyword}
            />
          </FilterElementLayout>
        </Grid>
      </Grid>

      <Grid>
        <Grid item xs={12}>
          <FilterElementLayout
            label={'Connect'}
            layoutStyles={{ alignItems: 'baseline' }}
            gridSize={1}
          >
            <Grid container direction={'row'}>
              <Grid item xs={6}>
                <MultipleSelectFilter<ConnectUserType>
                  label={'User Type'}
                  values={connectUserTypes}
                  options={connectUserTypeOption}
                  onChange={onChangeConnectUserType}
                  width={'200px'}
                  gridSize={3}
                />
              </Grid>
              <Grid item xs={6}>
                <MultipleSelectFilter<ConnectCommunityUserType>
                  label={
                    <TextWrapper fontWeight={'600'} textAlign={'left'} fontSize={'15px'}>
                      Community User Type
                    </TextWrapper>
                  }
                  values={connectCommunityUserTypes}
                  options={connectCommunityUserTypeOption}
                  onChange={onChangeConnectCommunityUserType}
                  width={'200px'}
                  gridSize={3}
                />
              </Grid>
            </Grid>
            <Grid container direction={'row'}>
              <Grid item xs={6}>
                <MultipleSelectFilter<ConnectAchievementBadge>
                  label={
                    <TextWrapper fontWeight={'600'} textAlign={'left'} fontSize={'15px'}>
                      Achievement Badge
                    </TextWrapper>
                  }
                  values={connectAchievementBadges}
                  options={CONNECT_ACHIEVEMENT_BADGE}
                  onChange={onChangeConnectAchievementBadge}
                  width={'200px'}
                  gridSize={3}
                />
              </Grid>
              <Grid item xs={6}>
                <MultipleCheckboxFilter<string>
                  statuses={connectAbusingUserCheckboxes}
                  onChangeChecked={onChangeConnectAbusingUser}
                  filterLabel={'Abusing User'}
                  checkedOptions={CONNECT_ABUSING_USER}
                  gridSize={3}
                />
              </Grid>
            </Grid>
          </FilterElementLayout>
        </Grid>
      </Grid>
    </MemberSeachFilterLayout>
  );
};

export default SearchFilter;
